import { useEffect } from "react";
import { useSelector } from "react-redux";
import { syncPushSubscription } from "../features/notifications/push-state";
import { selectSessionId } from "../redux/reducer/app-slice";
import { SUBSCRIPTION_CHANGED_MESSAGE } from "../utils/push-routing";

const sync = () => syncPushSubscription().catch((error) => console.error(error));

export const usePushSync = () => {
  const sessionId = useSelector(selectSessionId);

  useEffect(() => {
    if (sessionId) sync();
  }, [sessionId]);

  useEffect(() => {
    const container = navigator.serviceWorker;
    if (!container?.addEventListener) return undefined;
    const onMessage = ({ data } = {}) => {
      if (data?.type === SUBSCRIPTION_CHANGED_MESSAGE) sync();
    };
    container.addEventListener("message", onMessage);
    return () => container.removeEventListener("message", onMessage);
  }, []);
};
